export const MAKE_TIP_PAYMENT = "tips/MAKE_TIP_PAYMENT";
export const MAKE_TIP_PAYMENT_SUCCESS = "tips/MAKE_TIP_PAYMENT_SUCCESS";
export const MAKE_TIP_PAYMENT_FAIL = "tips/MAKE_TIP_PAYMENT_FAIL";
